import React, { useCallback } from 'react';

import { useFavoriteStorage, useTranslations } from 'src/hooks';
import { locals } from 'src/constants/locals';
import { SvgHeart } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgHeart';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/styles';
import { useHistory } from 'react-router';
import { useComparePageLink } from 'src/hooks/useComparePageLink';
import { useSelector } from 'react-redux';
import { requestSelectors } from 'src/store/requests/selectors';
import { WrapperMobileItem } from '../_WrapperMobileItem';
import { useStyles } from '../../styles';

interface IFavoritesBottom {
  isActive: boolean;
}

export const FavoritesBottom: React.FC<IFavoritesBottom> = React.memo(({
  isActive,
}) => {
  const theme: Theme = useTheme();
  const history = useHistory();
  const styles = useStyles({ isActive });
  const { comparePageRouteLink } = useComparePageLink();
  const { getTranslations } = useTranslations();
  const mainColor = useSelector(requestSelectors.app.getMainColors);
  const { favIdsList } = useFavoriteStorage();

  const RenderFavoriteIconWithCount = useCallback(() => {
    return (
      <Box
        sx={{
          position: 'relative',
          height: '24px',
          '& .appStrokeStyles': {
            stroke: !isActive ? theme.palette.primary.main : `${mainColor?.filterBackgroundColor}e6`,
          },
        }}
      >
        <SvgHeart width="24" height="24" fill={(favIdsList && favIdsList.length && !isActive) ? theme.palette.primary.main : `${mainColor?.filterBackgroundColor}e6`} />
        {favIdsList && favIdsList.length !== 0 && (
          <>
            <div className={styles.wrapperFavoriteCount}>
              <span>{`${favIdsList.length > 9 ? '9+' : favIdsList.length}`}</span>
            </div>
          </>
        )}
      </Box>
    );
  }, [styles, favIdsList]);

  return (
    <WrapperMobileItem
      isActive={isActive}
      iconItem={<RenderFavoriteIconWithCount />}
      text={getTranslations(locals.appTranslations.appFavorites)}
      handleClick={() => history.push(comparePageRouteLink)}
    />
  );
});
